import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
})
export class SelectComponent implements OnInit, ControlValueAccessor {
  value!: any;
  values: any[] = [];

  searchText = '';

  @Input() placeholder = '';
  @Input() items!: any[];
  @Input() containerClass =
    'dropdown dropdown-form-control dropdown-btn-middle';
  @Input() buttonClass = 'btn btn-form-control dropdown-toggle btn-block';
  searchedItems!: any[];
  @Input() valueProp = 'value';
  @Input() labelProp = 'label';
  @Input() search = false;
  @Input() wrong = false;
  @Input() spanClass = '';
  @Input() isMultipleValues = false;
  onChange = (value: any) => {};

  constructor() {}

  registerOnTouched(fn: any) {}

  writeValue(obj: string[] | string) {
    if (obj && this.items) {
      if (this.isMultipleValues) {
        this.values = this.items.filter((item) => (obj as string[]).includes(item[this.valueProp]));
      } else {
        this.value = this.items.find((item) => item[this.valueProp] === obj);
      }
    }
  }

  ngOnInit() {
    this.filterItems();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  onHide() {
    this.apply();
    this.searchText = '';
    this.filterItems();
  }

  apply() {
    if (this.isMultipleValues) {
      this.onChange?.(this.values.map((item: any) => item[this.valueProp]));
    } else {
      this.onChange?.(this.value?.[this.valueProp]);
    }
  }

  checkItem(item: any, dropdown: BsDropdownDirective) {
    if (this.isMultipleValues) {
      const index = this.values.findIndex((val: any) => val[this.valueProp] === item[this.valueProp]);

      if (item[this.valueProp] === this.items[0][this.valueProp]) {
        this.values = [this.items[0]];
        dropdown.hide();
      } else if (index !== -1) {
        this.values.splice(index, 1);
        if (!this.values.length) {
          this.values = [this.items[0]];
        }
      } else {
        const indexOfDefaultItem: number = this.values.findIndex(el => el[this.valueProp] === this.items[0][this.valueProp]);
        if (indexOfDefaultItem >= 0) {
          this.values.splice(indexOfDefaultItem, 1);
        }

        this.values.push(item);
      }

      this.apply();
    } else {
        this.value = item;
        dropdown.hide();
    }
  }

  filterItems() {
    this.searchedItems = this.items.filter((item) =>
      item?.[this.labelProp]
        .toLowerCase()
        .includes(this.searchText.toLowerCase())
    );
  }

  searchInput($event: Event) {
    const target = $event.target as HTMLInputElement;
    this.searchText = target.value;
    this.filterItems();
  }

  onKeyPress(event: KeyboardEvent, dropdown: BsDropdownDirective) {
    if (event.key === 'Enter' || event.key === 'Escape') {
      this.onHide();
      dropdown.hide();
    }
  }

  removeItemFromList(label: string) {
    const indexItem = this.values.findIndex(el => el[this.labelProp] === label);

    if (this.values.length > 1) {
      this.values.splice(indexItem, 1);
    } else {
      this.values = [this.items[0]];
    }
  }

  get getLabels(): string[] | any {
    return this.values.map((val) => val[this.labelProp]);
  }
}
